import React from "react";
import cn from "classnames";
import * as styles from "./RatingFooterLinks.module.scss";

function RatingFooterLinks({compactMode = true, inlineMode = false}) {
  return (
    <div className={cn(styles.root, compactMode && styles.compact, inlineMode && styles.inline)}>
      <div className={styles.stars}>
        <svg width="92" height="16" viewBox="0 0 92 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 0.552734L10.4922 5.1225L15.6085 6.0806L12.0325 9.86297L12.7023 15.0249L8 12.7927L3.29772 15.0249L3.96752 9.86297L0.391548 6.0806L5.50779 5.1225L8 0.552734Z"
            fill="#00D2AB"
          />
          <path
            d="M27 0.552734L29.4922 5.1225L34.6085 6.0806L31.0325 9.86297L31.7023 15.0249L27 12.7927L22.2977 15.0249L22.9675 9.86297L19.3915 6.0806L24.5078 5.1225L27 0.552734Z"
            fill="#00D2AB"
          />
          <path
            d="M46 0.552734L48.4922 5.1225L53.6085 6.0806L50.0325 9.86297L50.7023 15.0249L46 12.7927L41.2977 15.0249L41.9675 9.86297L38.3915 6.0806L43.5078 5.1225L46 0.552734Z"
            fill="#00D2AB"
          />
          <path
            d="M65 0.552734L67.4922 5.1225L72.6085 6.0806L69.0325 9.86297L69.7023 15.0249L65 12.7927L60.2977 15.0249L60.9675 9.86297L57.3915 6.0806L62.5078 5.1225L65 0.552734Z"
            fill="#00D2AB"
          />
          <path
            d="M84 0.552734L86.4922 5.1225L91.6085 6.0806L88.0325 9.86297L88.7023 15.0249L84 12.7927L79.2977 15.0249L79.9675 9.86297L76.3915 6.0806L81.5078 5.1225L84 0.552734Z"
            fill="#00D2AB"
          />
        </svg>
      </div>
      <div className={styles.content}>
        <span className={styles.text}>
          Rated 4.8 on&nbsp;
          <span className={styles.linksWrap}>
            <a href={"https://www.g2.com/products/fibery/reviews"}>
              {compactMode ? null : (
                <span className={styles.iconWrap}>
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_9634_55146)">
                      <path
                        d="M12.2109 24.5527C18.8384 24.5527 24.2109 19.1802 24.2109 12.5527C24.2109 5.92532 18.8384 0.552734 12.2109 0.552734C5.58352 0.552734 0.210938 5.92532 0.210938 12.5527C0.210938 19.1802 5.58352 24.5527 12.2109 24.5527Z"
                        fill="#FF492C"
                      />
                      <path
                        d="M17.4031 9.74486H15.3535C15.4087 9.42326 15.6079 9.24326 16.0111 9.03926L16.3879 8.84726C17.0623 8.50166 17.4223 8.11046 17.4223 7.47206C17.4223 7.07126 17.2663 6.75446 16.9567 6.52646C16.6471 6.29846 16.2823 6.18566 15.8551 6.18566C15.5246 6.18178 15.2001 6.27436 14.9215 6.45206C14.6407 6.62486 14.4319 6.84806 14.3023 7.12646L14.8951 7.72166C15.1255 7.25606 15.4591 7.02806 15.8983 7.02806C16.2703 7.02806 16.4983 7.22006 16.4983 7.48646C16.4983 7.70966 16.3879 7.89446 15.9607 8.11046L15.7183 8.22806C15.1927 8.49446 14.8279 8.79926 14.6167 9.14486C14.4055 9.49046 14.3023 9.92486 14.3023 10.4505V10.5945H17.4031V9.74486ZM17.1295 11.5737H13.7359L12.0391 14.5113H15.4327L17.1295 17.4513L18.8263 14.5113L17.1295 11.5737Z"
                        fill="#FEFEFE"
                      />
                      <path
                        d="M12.3334 16.4733C10.1734 16.4733 8.41416 14.7141 8.41416 12.5541C8.41416 10.3941 10.1734 8.63487 12.3334 8.63487L13.675 5.82927C13.2332 5.74141 12.7838 5.6972 12.3334 5.69727C8.54616 5.69727 5.47656 8.76687 5.47656 12.5541C5.47656 16.3413 8.54616 19.4109 12.3334 19.4109C13.7847 19.4136 15.199 18.9528 16.3702 18.0957L14.887 15.5229C14.1774 16.1358 13.271 16.4731 12.3334 16.4733Z"
                        fill="#FEFEFE"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_9634_55146">
                        <rect width="24" height="24" fill="white" transform="translate(0.210938 0.552734)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              )}
              G2
            </a>
          &nbsp;and&nbsp;
          <a href={"https://www.capterra.com/p/210658/Fibery/#reviews"}>
              {compactMode ? null : (
                <span className={styles.iconWrap}>
                  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 8.22904H9.29318H14.9367V2.63623L0 8.22904Z" fill="#FF9D28"/>
                    <path d="M14.9375 2.63588V22.405L22.0003 0L14.9375 2.63588Z" fill="#68C5ED"/>
                    <path d="M14.9365 8.22852H9.29297L14.9365 22.3879V8.22852Z" fill="#044D80"/>
                    <path d="M0 8.22852L10.7463 11.8613L9.29318 8.22852H0Z" fill="#E54747"/>
                  </svg>
                </span>
              )}
            Capterra
            </a>
          </span>
        </span>
      </div>
    </div>
  );
}

export default RatingFooterLinks;
